import { buildGarimposJsonLd } from "@/features/garimpos/garimpos-json-ld";
import { alternatesToLinks, buildLocalizedPageAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import type { CuratedCrate } from "@garimpa/lib/curatedCrates";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export async function buildGarimposHead(input: {
  locale: ViewerLocale;
  title: string;
  description: string;
  /** The rendered crates in page order; the JSON-LD `ItemList` lists exactly these. */
  crates: readonly CuratedCrate[];
  crateName: (crate: CuratedCrate) => string;
}) {
  const alternates = buildLocalizedPageAlternates(input.locale, "garimpos");
  const jsonLd = buildGarimposJsonLd(input);

  return {
    meta: await buildPagePreviewMetaTags(
      {
        title: input.title,
        description: input.description,
        canonicalUrl: alternates.canonical,
      },
      {
        robots: "index,follow",
        openGraph: { type: "website" },
        twitter: {},
      },
      { locale: input.locale },
    ),
    links: alternatesToLinks(alternates),
    scripts: [{ type: "application/ld+json", children: JSON.stringify(jsonLd) }],
  };
}
